import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreTypeForm from '../../../components/forms/ScoreTypeForm';
import { useScoreTypeById, useUpdateScoreType } from '../../../hooks/useScoreTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ScoreTypeDTO } from '../../../services/apiClient';

const ScoreTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useScoreTypeById(id);
  const updateMutation = useUpdateScoreType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Score Types', href: '/admin/scoretypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/scoretypes');
    } catch (error) {
      console.error('Error updating ScoreType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scoretypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ScoreType.Edit"
    >
      {entityData ? (
        <ScoreTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/scoretypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ScoreTypeEdit;
